import { mockDashboardStats } from '../mocks/dashboard';
import type { ActivityLogItem, DashboardStats } from '../types/admin';
import { apiRequest } from './client';

// Mock implementation — swap for real apiRequest call once backend adds admin dashboard stats endpoint.
export async function getDashboardStats(): Promise<DashboardStats> {
  await delay(250);
  return mockDashboardStats;
}

export async function getRecentActivity(accessToken: string): Promise<readonly ActivityLogItem[]> {
  return apiRequest<readonly ActivityLogItem[]>('/admin/activity/recent?limit=5', {
    token: accessToken,
  });
}

function delay(ms: number): Promise<void> {
  return new Promise((resolve) => setTimeout(resolve, ms));
}
